import { AboutMe } from "../../../../src/components/about-me";
import * as React from 'react';
export default {
  AboutMe,
  React
};